<template>
  <div>
    <div class="input-group py-0">
      <label>{{ label }}</label>
    </div>

    <v-layout row wrap>
      <v-flex>
        <v-text-field
          :type="$browser.isIE() ? 'text' : 'date'"
          placeholder="YYYY-MM-DD"
          v-model="date"
          hide-details
        />
      </v-flex>
      <v-flex>
        <v-text-field
          :type="$browser.isIE() ? 'text' : 'time'"
          placeholder="HH:MM"
          v-model="time"
          hide-details
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    value: [Date, String],
    required: Boolean,
    label: String
  },
  data () {
    let value = this.value
    let date = null
    let time = null

    if (value) {
      date = value.split('T')[0]
      time = value.split('T')[1]
    }

    return {
      date,
      time
    }
  },
  watch: {
    date () {
      this.updateValue()
    },
    time () {
      this.updateValue()
    }
  },
  methods: {
    updateValue () {
      let updated = this.value
      if (this.date) {
        updated = (this.date || '') + 'T' + (this.time || '00:00')
      } else {
        updated = ''
      }
      this.$emit('input', updated)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// DateTime.vue?29f6e010